module.exports = __webpack_public_path__ + "img/30.8c2e03fb.jpg";